import React from 'react';
import PremiacoesPage from './PremiacoesPage';
import cidadeSP from '../data/cidades/sao-paulo.json';
import premiacoesSP from '../data/premiacoes/sao-paulo.json';

const PremiacoesSPPage = () => (
  <PremiacoesPage cidade={cidadeSP} premiacao={premiacoesSP} />
);

export default PremiacoesSPPage;
